import { Button, IconReload16, UIHeading4, UIText1 } from '@cian/ui-kit';
import { FC } from 'react';
import { NBSP } from 'shared/constants/symbols';
import styles from './OffersLoadError.css';

interface IOffersErrorProps {
  onRetry: VoidFunction;
}

export const OffersLoadError: FC<IOffersErrorProps> = ({ onRetry }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['title-container']}>
        <UIHeading4 textAlign="center">Объявления не загрузились</UIHeading4>
      </div>
      <div className={styles['subtitle-container']}>
        <UIText1 color="gray60_100" textAlign="center">
          Попробуйте обновить или{NBSP}зайдите чуть позже
        </UIText1>
      </div>
      <div className={styles['button-container']}>
        <Button beforeIcon={<IconReload16 color="primary_100" />} theme="fill_secondary" onClick={onRetry}>
          Обновить
        </Button>
      </div>
    </div>
  );
};
